import { Component, ElementRef, HostBinding, Input, Optional, Renderer2, Self, ViewChild } from "@angular/core";
import { NgControl } from "@angular/forms";
import { SpsIcon } from "@spscommerce/ds-shared";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-text-input",
    templateUrl: "./sps-text-input.component.html",
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsTextInputComponent }]
})
export class SpsTextInputComponent extends SpsFormControlComponent<string> {
    static readonly displayName = "sps-text-input";
    static readonly props = {
        placeholder: "string",
        icon: "SpsIcon",
    };

    @Input() placeholder = "";
    @Input() icon: SpsIcon;

    @HostBinding("class.sps-text-input") readonly _spsTextInputClass = true;

    @ViewChild("textInput", { static: false }) inputElement: ElementRef;

    get value(): string {
        return this.model;
    }
    set value(newValue: string) {
        this.model = newValue;
    }

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl
    ) {
        super(el, renderer, ngControl);
    }
}
